// Converts numbers to include commas
export function numberWithCommas(x) {
  if (x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else {
    return x;
  }
}

// Returns the Decimal Minute Seconds
export function renderDecimalMinuteSeconds(a) {
  var d = parseInt(a);
  var dF = Math.abs(a - d);
  var m = parseInt(dF * 60);
  var s = (dF - m / 60) * 3600;
  return Math.abs(d) + "\u00b0 " + m + "' " + s.toFixed(2) + '"';
}

// check empty String
export function isEmpty(str) {
  return !str || 0 === str.length;
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
